// third party libarrys
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import useReactRouter from "use-react-router";
import {
  // Tab,
  // Tabs,
  Form,
  Modal,
  Button,
  Spinner,
  Alert,
  Container,
  // ButtonGroup
} from "react-bootstrap";
import { useToasts } from "react-toast-notifications";

// components
import { CREATE_ORDER_CONFIRM_WIDTH_PAYMENT } from "../../../graphql/order/mutation";
import { GET_USER_CONFIRMS } from "../../../graphql/userConfirm/query";
import useWindowDimensions from "../../../helpers/useWindowDimensions";
import { GET_EXCHANGRATE } from "../../../graphql/exchangeRate/Query";
import { CREATE_USER_CONFIRM } from "../../../graphql/userConfirm/mutation";
import { GET_PAYMENT_TAXE } from "../../../graphql/partner/query";
import { BG_GRADIENT_NEW, COLOR_APP, COLOR_TEXT, COLOR_WHITE, LINEAR_GRADIENT_BG } from "../../../constants";
import { convertPriceWithCommission, imageRender } from "../../../helpers";
import { GET_ORDERGROUPS_DETAIL } from "../../../graphql/order/query";
import OrderGroupDetail from "./OrderGroupDetail";
import ShopInfoOrderConfirm from "./ShopInfoOrderConfirm";
import FinishOrder from "./FinishOrder";
// import { GET_BANKS } from "../../../graphql/bank/query";
import { GET_SETTINGS, GET_SETTING_BY_SHOP } from "../../../graphql/setting/query";

// images
import lailaoPaymentIcon from "../../../image/lailao_payment_icon.png"
import ListReceiveAddress from "../../settings/settingLogictics/settingReceive/ListReceiveAddress";
import ReceiveDeliveryAddress from "../../settings/settingLogictics/settingReceive/CardDefaultReceiveAddress";
import { GET_MANY_USER_ADDRESS_USER_ID } from "../../../graphql/userConfirm/userAddress/query";
import FormReceiveAddress from "../../settings/settingLogictics/settingReceive/FormReceiveAddress";
import UserVerifyIdentity from "../../users/UserVerifyIdentity";
import { ADD_ORDER_DELIVERY } from "../../../graphql/orderDelivery/mutation";
import ConfirmCOD from "./ConfirmCOD";
import LoadingAbsolute from "../../../components/loading/LoadingAbsolute";
// import ConfirmPaymentAuto from "./confirm_payment_auto";

function MultiStepForm() {
  const { history, match, location } = useReactRouter();

  // State
  const { width, height } = useWindowDimensions()
  const [orderData, setOrderData] = useState();
  const [firsStep, setFirstStep] = useState(true);
  const [secondStep, setSecondStep] = useState(false);
  const [lastStep, setLastStep] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [isAlert, setIsAlert] = useState(false);
  const [shopId, setShopId] = useState()
  const [shopRate, setShopRate] = useState()
  const [paymentSupports, setPaymentSupports] = useState({
    partner: '',
  })
  const [taxPrice, setTaxPrice] = useState(0)
  const [showPreview, setShowPreview] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState();

  const { addToast } = useToasts();

  //! USER VERIFY_IDENTITY
  const [isVerifyIdentity, setIsVerifyIdentity] = useState(false);
  const [idDataUserConfirm, setIdDataUserConfirm] = useState({});
  const [isModalVerifyIdentity, setIsModalVerifyIdentity] = useState(false);
  const onCloseModalVerifyIdentity = () => setIsModalVerifyIdentity(false);

  //! RECEIVE ADDRESS
  const [isReceiveData, setIsReceiveData] = useState({});
  const [isAddModal, setIsAddModal] = useState(false);
  const onCloseModalAdd = () => setIsAddModal(false);
  const [isUseLogicstics, setIsUseLogicstics] = useState("NOT_USE_LOGICSTIC")
  const [isShipMentPaytype, setIsShipMentPayType] = useState({
    isOpenCod: false,
    data: null
  })

  const [userAddressUserId_API, { data: userAddressUserId_DATA }] =
    useLazyQuery(GET_MANY_USER_ADDRESS_USER_ID, {
      fetchPolicy: "cache-and-network",
    });

  useEffect(() => {
    if (!_.isEmpty(isReceiveData)) {
      setCustomerName(isReceiveData?.userName);
      setAddress(isReceiveData?.address);
      setPhone(isReceiveData?.userTel);
    }
  }, [isReceiveData]);

  useEffect(() => {
    if (!isVerifyIdentity) {
      if (isVerifyIdentity) onCloseModalVerifyIdentity();
    }
  }, [isVerifyIdentity]);

  useEffect(() => {
    // GET User Address By User ID
    fetchUserAddressUserId_API();
  }, [idDataUserConfirm]);

  const fetchUserAddressUserId_API = async () => {
    try {
      await userAddressUserId_API({
        variables: {
          where: {
            user: idDataUserConfirm?.id
          },
        },
      });
    } catch (err) {
      console.log("ERROR_fetchUserAddressUserId_API")
    }
  };

  //! ADD_USER_ADDRESS
  const [addOrderDelivery_API, { loading: addOrderDeliveryLoading }] = useMutation(ADD_ORDER_DELIVERY);
  const addOrderDeliveryWeb = async () => {
    try {
      const newAddOrderDelivery_API = await addOrderDelivery_API({
        variables: {
          data: {
            shipment_pay_type: orderData?.orders[0]?.stock?.shipment_pay_type ?? "CDC",
            latLong: isReceiveData?.latLong,
            sender: isReceiveData?.sender,
          },
          where: {
            delivery: isReceiveData?.deliveryName,
            orderGroupId: orderData?.id,
            userAddressId: isReceiveData?.id,
            shop: orderData?.shop?.id
          }
        }
      });
      if (newAddOrderDelivery_API?.data?.addOrderDelivery?.message !== "Success") throw newAddOrderDelivery_API?.data?.addOrderDelivery?.message;
      return { isError: false };
    } catch (err) {
      addToast("ສ້າງຂົນສົ່ງບໍ່ສຳເລັດ", {
        appearance: "error",
        autoDismiss: true,
      });
      console.log("ERROR_addOrderDeliveryWeb");
      return { isError: true };
    }
  }

  const { data: paymentTaxDatas } = useQuery(GET_PAYMENT_TAXE);
  // const [getBankData, { data: bankData, loadingBank }] = useLazyQuery(GET_BANKS, {
  //   fetchPolicy: "cache-and-network",
  // });
  const [getShopSetting, { data: shopSettingData, loadingSetting }] = useLazyQuery(
    GET_SETTINGS,
    { fetchPolicy: "cache-and-network" }
  );
  const [getOrderData, { data: _orderData, loading: _orderLoading }] =
    useLazyQuery(GET_ORDERGROUPS_DETAIL, { fetchPolicy: "network-only" });


  const [confirmOrderGroups, { loading: loadingConfirmOrder }] = useMutation(
    CREATE_ORDER_CONFIRM_WIDTH_PAYMENT
  );

  const [getUserConfirms, { data: userConfirmDatas }] =
    useLazyQuery(GET_USER_CONFIRMS);
  const [getExchangeRate, { data: loadExchangeRate, loadingExchange }] = useLazyQuery(
    GET_EXCHANGRATE,
    { fetchPolicy: "cache-and-network" }
  );
  // setting by shop
  const { data: settingData, refetch: fetchSettingData } = useQuery(GET_SETTING_BY_SHOP, {
    fetchPolicy: "network-only",
    variables: {
      where: {
        shop: shopId,
      },
    },
  });

  const [createUserConfirm] = useMutation(CREATE_USER_CONFIRM);

  const pathname = location?.pathname;
  const _orderId = pathname.split('/').pop();

  useEffect(() => {
    getExchangeRate({
      variables: {
        where: {
          shop: shopId,
        },
      },
    });
  }, [shopId]);

  useEffect(() => {
    if (match?.params?.data) {
      let matchData = match?.params?.data.split("&&");
      getLiveOrder(matchData[0], matchData[1]);
      fetchSettingData()

    }
  }, [match?.params?.data]);

  // ກວດສອບເງື່ອນໄຂການນຳໃຊ້ຟັງຊັ່ນ
  useEffect(() => {
    if (paymentTaxDatas || settingData) {

      // ຖ້ານຳໃຊ້ payment gateway ຈຶ່ງເກັບຄ່າ fee
      if (settingData?.settingByShopId?.isPaymentGateway) {
        setTaxPrice(paymentTaxDatas?.paymentSupportCurrencyLAKTax?.data?.taxPrice)
      }
      // ຖ້ານຳໃຊ້ ຂົນສົ່ງ ຈຶ່ງສະແດງ ຂົນສົ່ງ
      // if(settingData?.settingByShopId?.isUseLogicstics) {
      //   setIsUseLogicstics("NOT_USE_LOGICSTIC")
      // }


    }
  }, [paymentTaxDatas, settingData]);

  useEffect(() => {
    if (!_.isEmpty(_orderData?.orderGroup)) {
      _fetchShopSetting(_orderData?.orderGroup?.shop?.id);
      // _fetchBank(_orderData?.orderGroup?.shop?.id);
      setOrderData(_orderData?.orderGroup);
      setCustomerName(_orderData?.orderGroup?.cfName || _orderData?.orderGroup?.customerName);
      setAddress(`${_orderData?.orderGroup?.logistic || ""} ${_orderData?.orderGroup?.addressCf || ""}`);
      setPhone(_orderData?.orderGroup?.phone);
      setShopId(_orderData?.orderGroup?.shop?.id)

    }
    if (_orderData?.orderGroup?.phone && _orderData?.orderGroup?.paySlip) {
      setSecondStep(true);
      setLastStep(true);
    }


  }, [_orderData]);

  // get user confirm
  useEffect(() => {
    if (orderData && !_.isEmpty(orderData.userFbId)) {
      getUserConfirms({
        variables: {
          where: {
            psid: orderData?.userFbId
          },
          orderBy: "createdAt_DESC"
        },
      });
    }
  }, [orderData]);

  useEffect(() => {
    if (userConfirmDatas?.userConfirms?.data) {
      // const customerJsonData = localStorage.getItem('CUSTOMER_DATA');
      // let customerData = {};
      // if (customerJsonData) {
      //   customerData = JSON.parse(customerJsonData)
      // }
      setPhone(userConfirmDatas?.userConfirms?.data[0]?.phone);
      setAddress(userConfirmDatas?.userConfirms?.data[0]?.addressCF);
    }
  }, [userConfirmDatas]);

  useEffect(() => {
    if (loadExchangeRate?.exchangeRate) {
      setShopRate(loadExchangeRate?.exchangeRate)
    }
  }, [loadExchangeRate]);

  const getLiveOrder = async (_liveId, _userFbId) => {
    try {
      getOrderData({
        variables: {
          where: {
            // live: _liveId,
            // cfName: _userFbId,
            // userFbId: _userFbId,
            id: _liveId,
            // isDeleted: false
          },
          orderBy: "createdAt_DESC",
        },
      });
    } catch (error) {
      console.log("Error retrieving posts", error);
    }
  };

  const _fetchShopSetting = async (shopId) => {
    getShopSetting({
      variables: {
        where: { shop: shopId },
        orderBy: "createdAt_ASC",
      },
    });
  };

  // const _fetchBank = async (shopId) => {
  //   try {
  //     getBankData({
  //       variables: {
  //         where: {
  //           shop: shopId,
  //           isDeleted: false,
  //         },
  //         skip: 0,
  //         limit: 100,
  //         orderBy: "createdAt_DESC",
  //       },
  //     });
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const onConfirmForClient = async () => {
    try {
      if (!phone || !address) {
        setIsAlert(true);
        return;
      }

      if (loadingConfirmOrder) return;

      //! RECEIVE
      if (isUseLogicstics === "IS_USE_LOGICSTIC") {
        const newAddOrderDelivery = await addOrderDeliveryWeb();
        if (newAddOrderDelivery && newAddOrderDelivery.isError) throw "ERROR_CREATE_DELIVERY";
      }

      // let get_taxPrice = localStorage.getItem("TAX_PRICE");
      // let _taxPrice = parseInt(get_taxPrice);
      // setIsAlert(false);

      // let priceToPaid = await calculateRoundedValue(priceProduct / 1000) * 1000;
      let priceToPaid = convertPriceWithCommission(orderData?.totalPrice, orderData?.sumPriceBaht, orderData?.sumPriceUsd, taxPrice, shopRate);

      // create user confirm
      await createUserConfirm({
        variables: {
          data: {
            name: customerName,
            phone: phone,
            addressCF: address,
            psid: orderData?.userFbId,
            shop: orderData?.shop?.id,
          },
        },
      }).catch((err) => console.log(err));

      let newDta = {
        // amount: priceToPaid,
        // amount: 1,
        shopName: orderData?.shop?.name,
        shop: orderData?.shop?.id,
        phone: phone,
        addressCf: address,
        customerName: customerName
      };
      let newWhere = {
        orderGroupId: orderData?.id,
        shop: orderData?.shop?.id
      };
      if (orderData?.sumPriceBaht > 0  || orderData?.sumPriceUsd > 0 && shopRate) {
        newWhere = {...newWhere, rate: JSON.stringify(shopRate)}
      }

      // update and confirm orderGroup
      const response = await confirmOrderGroups({
        variables: {
          data: newDta,
          where: newWhere,
        },
      });

      if (response) {
        setShowPreview(true);
        let _response = JSON.parse(response?.data?.createPaymentOrder?.data);
        let link = JSON.parse(_response?.data).redirectURL;
        setQrCodeUrl(link)
      }

    } catch (error) {
      console.log({ error });
      addToast("ເກີດຂໍ້ຜິດພາດ  ກະລຸນາລອງໃຫມ່ພາຍຫລັງ", {
        appearance: "error",
        autoDismiss: true,
      });
      setIsAlert(false);
    }
  };



  // on selelct mode of payment 
  const onModePayment = async (e) => {
    if (e === "MANUAL_PAYMENT") {
      setTaxPrice(0)
      setPaymentSupports({
        partner: null,
        // // on selelct mode of payment 
        // const onModePayment = async (e) => {
        //   if (e === "MANUAL_PAYMENT") {
        //     setTaxPrice(0)
        //     setPaymentSupports({
        //       partner: null
        //     })
        //   } else {

      })
    } else {

      let _taxPrice = localStorage.getItem("TAX_PRICE")
      if (settingData?.settingByShopId?.isPaymentGateway) {
        setTaxPrice(parseInt(_taxPrice))
      }
      setPaymentSupports({
        partner: "LAILAO_PAYMENT_SUPPORT"
      })
    }
  }

  // onclose modal confirm cod for customer
  const handleCloseCodModal = () => {
    setIsShipMentPayType({
      isOpenCod: false,
      data: null
    })
  }

  if (_orderLoading || loadingSetting || loadingExchange || addOrderDeliveryLoading) return <LoadingAbsolute />;

  return (<>
    {/* {!shopSettingData?.isPaymentGateway ? 
      <div
        style={{ textAlign: "center" }}>
        <p>ກະລຸນະຕັ້ງຄ່າໃຫ້ຄົບຖ້ວນ(ເພີ່ມບັນຊີທະນາຄານ ຫລື ນຳໃຊ້ Payment gateway)</p>
        <p>ແລ້ວຮີເຟສເພື່ອລອງໃຫມ່ອີກຄັ້ງ</p>
        <p>ລາຍລະອຽດເພີ່ມເຕີ່ມ ສາມາດຕີດຕໍ່support: 4B</p>
      </div>
    :(
    )} */}
      <Container style={{ background: orderData?.isPaymented ? LINEAR_GRADIENT_BG : "#fff", padding: 10, maxWidth: 480 }}>
        {!orderData?.isPaymented &&
          <div style={{ display: "flex", width: "100%" }}>
            <img
              src={imageRender(orderData?.shop?.image)}
              style={{
                width: 80,
                height: 80,
                marginTop: 5,
                marginLeft: 5,
                borderRadius: ".5em",
              }}
            />
            <div
              style={{ display: "flex", flexDirection: "column", marginLeft: 10 }}
            >
              <div
                style={{
                  display: "flex",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "68vw",
                }}
              >
                ຮ້ານ: {orderData?.shop?.name}
              </div>
              <div
                style={{
                  display: "flex",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "68vw",
                }}
              >
                ເພຈ: {orderData?.live?.pageName ?? orderData?.post?.pageName}
              </div>
              <div
                style={{
                  display: "flex",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "68vw",
                }}
              >
                ເບີໂທ: {orderData?.shop?.phone}
              </div>
              <div
                style={{
                  display: "flex",
                  fontSize: 12,
                }}
              >
                ທີ່ຢູ່: {orderData?.shop?.address?.village},{" "}
                {orderData?.shop?.address?.district},{" "}
                {orderData?.shop?.address?.province}
              </div>
            </div>
          </div>
        }

        {(!orderData?.isPaymented && settingData?.settingByShopId?.isUseLogistics) && <div className="mt-4 pl-2 d-flex gap-2">
          <Button variant={isUseLogicstics === "NOT_USE_LOGICSTIC" ? "outline-secondary": "light"} onClick={() => setIsUseLogicstics("NOT_USE_LOGICSTIC")} style={{width:'100%', background: isUseLogicstics === "NOT_USE_LOGICSTIC" ? LINEAR_GRADIENT_BG : COLOR_WHITE, color: isUseLogicstics === "NOT_USE_LOGICSTIC" ? COLOR_WHITE : COLOR_TEXT,  border: isUseLogicstics === "NOT_USE_LOGICSTIC"? "none": "1px solid #ddd" }}> ຂົນສົ່ງອື່ນໆ</Button>
          <Button variant={isUseLogicstics === "IS_USE_LOGICSTIC" ? "outline-secondary": "light"} onClick={() => { setIsModalVerifyIdentity(true); setIsUseLogicstics("IS_USE_LOGICSTIC");}} style={{ width:'100%',background: isUseLogicstics === "IS_USE_LOGICSTIC" ? LINEAR_GRADIENT_BG : COLOR_WHITE, color: isUseLogicstics === "IS_USE_LOGICSTIC" ? COLOR_WHITE : COLOR_TEXT, border: isUseLogicstics === "IS_USE_LOGICSTIC"? "none": "1px solid #ddd" }}>ຮຸ່ງອາລຸນ ແລະ ມີໄຊ</Button>
        </div>}

        {orderData?.isPaymented ? (
          <FinishOrder
            orderData={orderData}
            taxPrice={taxPrice ?? null}
            shopRate={shopRate}
          />
          // <ConfirmPaymentAuto orderData={orderData} shopRate={shopRate} taxPrice={taxPrice} />
        ) : (
          <div style={{ width: "100%" }}>
            {settingData?.settingByShopId?.isPaymentGateway ? (
              <>
                {!orderData?.isPaymented ? (
                  <>
                    {/* //! VERIFY_USER */}
                    {!isVerifyIdentity && (
                      <div style={{
                        // border: '1px solid #E5E5E5',
                        padding: '15px',
                        borderRadius: '5px',
                        backgroundColor: '#fff',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}>
                        <Modal centered show={isModalVerifyIdentity}>
                          <Modal.Header >
                            <Modal.Title>ຢືນຢັນຕົວຕົນດ້ວຍເບີໂທ</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <UserVerifyIdentity
                              setDataUserConfirm={setIdDataUserConfirm}
                              onCloseModalVerifyIdentity={onCloseModalVerifyIdentity}
                              setIsUseLogicstics={setIsUseLogicstics}
                              setIsVerifyIdentity={setIsVerifyIdentity} />
                          </Modal.Body>
                        </Modal>
                      </div>
                    )}

                    <div
                      style={{
                        background: "#fff",
                        borderRadius: ".5em",
                        padding: "10px 0",
                      }}
                    >
                      {isAlert && (
                        <Alert variant="danger" onClick={() => setIsAlert(false)} dismissible>
                          ກາລຸນາປ້ອນ ເບີໂທ ແລະ ທີ່ຢູ່ປາຍທາງ ໃຫ້ຄົບຖ້ວນ!
                        </Alert>
                      )}

                      {/* //! RECEIVE ADDRESS */}
                      {/* <div style={{ fontWeight: "bold", width: "100%", textAlign: "left" }}>
                        ຂົນສົ່ງ
                      </div> */}

                      {isUseLogicstics === "IS_USE_LOGICSTIC" ? (
                        <>

                          {!_.isEmpty(userAddressUserId_DATA?.userAddressUserId?.data) ? (


                            <ReceiveDeliveryAddress
                              userAddress={userAddressUserId_DATA?.userAddressUserId?.data}
                              setIsReceiveData={setIsReceiveData}
                              userConfirm={!_.isEmpty(idDataUserConfirm) ? idDataUserConfirm : null}
                              psid={orderData?.userFbId}
                              orderGroup={orderData}
                            />


                          ) : (
                            <div style={{
                              border: '1px solid #E5E5E5',
                              padding: '15px',
                              borderRadius: '5px',
                              backgroundColor: '#fff',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}>
                              <Button onClick={() => setIsAddModal(true)} size='sm' variant='danger'>***** ກະລຸນາສ້າງທີ່ຢູ່ສຳລັບຂົນສົ່ງຂອງທ່ານ!. *****</Button>
                              <Modal centered show={isAddModal} onHide={onCloseModalAdd}>
                                <Modal.Header closeButton>
                                  <Modal.Title>ເພີ່ມທີ່ຢູ່ສຳລັບການຈັດສົ່ງ</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <FormReceiveAddress
                                    userConfirm={!_.isEmpty(idDataUserConfirm) ? idDataUserConfirm : null}
                                    psid={orderData?.userFbId}
                                    onCloseModalAdd={onCloseModalAdd}
                                    fetchUserAddressData={fetchUserAddressUserId_API}
                                    orderData={orderData}
                                  />
                                </Modal.Body>
                              </Modal>
                            </div>
                          )}
                        </>
                      ) : (
                        <div
                          style={{
                            background: "#fff",
                            borderRadius: ".5em",
                            padding: 10,
                          }}
                        >
                          {isAlert && (
                            <Alert variant="danger" onClick={() => setIsAlert(false)} dismissible>
                              ກາລຸນາປ້ອນ ເບີໂທ ແລະ ທີ່ຢູ່ປາຍທາງ ໃຫ້ຄົບຖ້ວນ!
                            </Alert>
                          )}
                          <Form.Group className="mb-3">
                            <Form.Label>ຊື່ລູກຄ້າ (ຈຳເປັນ)</Form.Label>
                            <Form.Control
                              value={customerName}
                              onChange={(e) => setCustomerName(e?.target?.value)}
                              type="text"
                            />
                          </Form.Group>
                          <Form.Group className="mb-3">
                            <Form.Label>ເບີໂທ (ຈຳເປັນ)</Form.Label>
                            <Form.Control
                              value={phone}
                              onChange={(e) => {
                                let _phone = e?.target?.value;
                                if (_phone?.length > 11) return;
                                setPhone(_phone);
                              }}
                              type="text"
                              placeholder="020 ຫຼື 030, ..."
                            />
                          </Form.Group>
                          <Form.Group className="mb-3">
                            <Form.Label>
                              ທີ່ຢູ່ຂົນສົ່ງ ພິມຊື່ຂົນສົ່ງ ສາຂາ ໃຫ້ລະອຽດ (ຈຳເປັນ)
                            </Form.Label>
                            <Form.Control
                              value={address}
                              onChange={(e) => setAddress(e?.target?.value)}
                              as="textarea"
                              type="text"
                            />
                          </Form.Group>
                        </div>
                      )}

                    </div>
                  </>
                ) : (
                  <p
                    style={{
                      width: "100%",
                      textAlign: "center",
                      color: "green",
                      fontSize: 28,
                    }}
                  >
                    ຈ່າຍເງິນແລ້ວ
                  </p>
                )}
              </>
            ) : (
              <ShopInfoOrderConfirm
                setSecondStep={setSecondStep}
                setLastStep={setLastStep}
                orderData={orderData}
                shopSettingData={shopSettingData}
                getLiveOrder={getLiveOrder}
                isUseLogicstics={isUseLogicstics}
                setIsUseLogicstics={setIsUseLogicstics}
                isAlert={isAlert}
                setIsAlert={setIsAlert}
                isModalVerifyIdentity={isModalVerifyIdentity}
                setIsModalVerifyIdentity={setIsModalVerifyIdentity}
                setIsShipMentPayType={setIsShipMentPayType}
                isShipMentPayType={isShipMentPaytype}
                settingDataByShop={settingData}
                shopRate={shopRate}
              />
            )}


            <OrderGroupDetail
              orderData={orderData}
              taxPrice={taxPrice ?? null}
              shopRate={shopRate}
              setSecondStep={setSecondStep}
              isPaymented={orderData?.isPaymented}
            />

            {(!orderData?.isPaymented && settingData?.settingByShopId?.isPaymentGateway && paymentSupports?.partner !== null) &&
              <Button
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: 20,
                  border: "none",
                  background: COLOR_APP,
                  width: '100%',
                  padding: 15,
                  borderRadius: 0
                }}
                disabled={loadingConfirmOrder ? true : false}
                onClick={onConfirmForClient}
              >
                {loadingConfirmOrder && <Spinner />} {settingData?.settingByShopId?.isPaymentGateway ? "ຂໍ QR ຊຳລະເງີນ" : "ຢືນຢັນການຊຳລະ"}
              </Button>
            }

          </div>
        )}


        <Modal size="lg" centered show={showPreview} onHide={() => setShowPreview(false)} >
          <Modal.Body style={{ width: '100%', height: "85vh", display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', position: 'relative' }}>
            <iframe src={qrCodeUrl} title="description" style={{ width: '100%', height: '100%' }}>

            </iframe>
            {/* <img style={{   width: 140, objectFit: 'contain', }} src="https://us.123rf.com/450wm/asagraphia/asagraphia2212/asagraphia221200361/195674474-flat-isometric-3d-illustration-online-payment-security.jpg?ver=6" />
            <h4>ທ່ານກຳລັງພະຍາຍາມຊຳລະເງິນຢູ່</h4>
            <Button onClick={() => setShowPreview(false)} style={{background: BG_GRADIENT_NEW, color: COLOR_WHITE, border:'none'}} >
                <MdClose style={{ fontSize: 18 }} /> ປິດໜ້ານີ້
              </Button> */}
          </Modal.Body>

        </Modal>

        {/*  confirm COD for customer */}
        <ConfirmCOD isShipMentPaytype={isShipMentPaytype} setIsShipMentPayType={setIsShipMentPayType} handleCloseCodModal={handleCloseCodModal} />

      </Container>
  </>
  );
}

export default MultiStepForm;
